import { supabase, Campaña } from '../lib/supabase';

export const campanaService = {
  async getByLumisial(lumisialId: string): Promise<Campaña[]> {
    const { data, error } = await supabase
      .from('campañas')
      .select('*')
      .eq('lumisial_id', lumisialId)
      .order('fecha_inicio', { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<Campaña | null> {
    const { data, error } = await supabase
      .from('campañas')
      .select('*')
      .eq('id', id)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getActiveCountByLumisial(lumisialId: string): Promise<number> {
    const { count, error } = await supabase
      .from('campañas')
      .select('*', { count: 'exact', head: true })
      .eq('lumisial_id', lumisialId)
      .in('estado', ['planificacion', 'en_curso']);

    if (error) throw error;
    return count || 0;
  },

  async create(campaña: Omit<Campaña, 'id' | 'created_at'>): Promise<Campaña> {
    const { data, error } = await supabase
      .from('campañas')
      .insert(campaña)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, campaña: Partial<Omit<Campaña, 'id' | 'created_at'>>): Promise<Campaña> {
    const { data, error } = await supabase
      .from('campañas')
      .update(campaña)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async updateEstado(id: string, estado: 'planificacion' | 'en_curso' | 'finalizada'): Promise<Campaña> {
    const { data, error } = await supabase
      .from('campañas')
      .update({ estado })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const { error } = await supabase
      .from('campañas')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
